/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, FormGroup, FormLabel, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const InputGroupV2 = ({
  children,
  label,
  title,
  placement,
  useTooltip,
  isRequired,
  className,
}) => {
  const labelValue = isRequired ? `${label}:*` : `${label}:`;

  return (
    <FormGroup
      component="fieldset"
      className={className}
      sx={{ width: '100%', border: 'none', m: 0, p: 0, minWidth: 0 }}
    >
      <FormLabel
        component="legend"
        sx={{
          color: 'text.secondary',
          fontSize: (theme) => theme.typography.body2.fontSize,
          fontWeight: 400,
          lineHeight: 1.5,
          mb: 0.25,
          width: '100%',
          '&.Mui-focused': {
            color: 'text.secondary',
          },
        }}
      >
        {useTooltip ? (
          <Box
            component="span"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}
          >
            <Box component="span">{labelValue}</Box>
            <Tooltip arrow placement={placement} title={title}>
              <InfoOutlinedIcon
                sx={{
                  width: 15,
                  height: 15,
                  color: 'info.main',
                  verticalAlign: 'middle',
                }}
              />
            </Tooltip>
          </Box>
        ) : (
          labelValue
        )}
      </FormLabel>
      <Box sx={{ width: '100%' }}>{children}</Box>
    </FormGroup>
  );
};

InputGroupV2.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isRequired: PropTypes.any,
  label: PropTypes.string.isRequired,
  placement: PropTypes.string,
  title: PropTypes.string,
  useTooltip: PropTypes.bool,
};

InputGroupV2.defaultProps = {
  isRequired: false,
  placement: 'top',
  useTooltip: false,
  title: '',
  className: null,
};

export default InputGroupV2;
